import { connect } from 'react-redux';
import { compose, withProps, flattenProp } from 'recompose';
import { withFirestore } from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { get5MostRecentUploads } from '../../../store/selectors/youtube';
import { loadChannelUploads } from '../../../store/actions/youtubeActions';
import {
  getDealList,
  getActiveDealsCount,
  getPendingDealsCount,
  getPendingMatchesForInfluencerCount,
  getCompleteDealsCount
} from '../../../store/selectors/deals';
import { loadRelevantCampaigns } from '../../../store/actions/campaignActions';
import { influencerInterestedFromDashboard } from '../../../store/actions/dealActions';
import {
  text__primary,
  text__primary_dark,
  white,
  deepPurple,
  grey,
  grey_dark,
  text__secondary
} from '../../../style';

const styles = theme => ({
  root: {
    display: 'flex'
  },
  title: {
    color: deepPurple,
    marginBottom: '30px'
  },
  dashboardContainer: {
    width: 'auto',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      width: '100%',
      boxSizing: 'border-box'
    }
  },
  youtubeVideoUpload: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '30px',
    height: '0',
    overflow: 'hidden',
    '& iframe': {}
  },
  iframeContainer: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  },
  dealItem: {
    width: '200px',
    height: '250px',
    backgroundColor: '#F3F3F3',
    marginRight: '10px'
  },
  relevantInfluencersContainer: {
    marginRight: '15px'
  },
  influencerItem: {
    width: '200px',
    height: '250px'
  },
  influencerListTop: {
    backgroundColor: '#F3F3F3',
    height: '8.4%'
  },
  influencerListMiddle: {
    height: '75%'
  },
  influencerListBottomNotMatched: {
    backgroundColor: '#5DBE76',
    cursor: 'pointer'
  },
  influencerListBottomMatchRequested: {
    backgroundColor: '#B8E3C3',
    cursor: 'pointer'
  },
  influencerContentContainer: {
    height: '100%'
  },
  influencerContentTop: {
    height: '40%'
  },
  influencerContentMiddle: {
    height: '20%'
  },
  influencerContentBottom: {
    height: '40%'
  },
  profilePicture: {
    height: '96px',
    width: '96px',
    '& > img': {
      borderRadius: '50%',
      height: '100%',
      width: '100%'
    }
  },
  campaignLink: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  subTitle: {
    marginBottom: 20
  },
  card: {
    height: '100%'
  },
  cardContent: {
    textAlign: 'center',
    '& > *': {
      marginTop: '10px',
      marginBottom: '10px'
    }
  },
  cardIcon: {
    backgroundColor: 'rgba(34, 194, 110, 0.08)',
    cursor: 'initial'
  },
  suggestCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  suggestCardHeader: {
    backgroundColor: '#F3F3F3',
    minHeight: '50px'
  },
  suggestCardContent: {
    height: '100%'
  },
  youtubeIcon: {
    color: white,
    width: '25px',
    height: '25px'
  },
  requestText: {
    color: white,
    paddingTop: 10,
    paddingBottom: 10,
    width: '100%'
  },
  add: {
    color: white
  },
  suggestCardActions: {
    padding: 0
  },
  carousel: {
    margin: '2px'
  },
  paymentButton: {
    color: 'white',
    marginTop: '20px'
  },
  interestsHeader: {
    textOverflow: 'ellipsis',
    maxHeight: '30px',
    overflowX: 'hidden'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    youtubeUploads: get5MostRecentUploads(state),
    relevantCampaigns: state.relevantCampaigns,
    dealList: getDealList(state),
    activeDealsCount: getActiveDealsCount(state),
    pendingDealAccepted: getPendingDealsCount(state),
    pendingMatchesCount: getPendingMatchesForInfluencerCount(state),
    completedDealsCount: getCompleteDealsCount(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadRelevantCampaignsHandler: uid => dispatch(loadRelevantCampaigns(uid)),
    interestedClickHandler: (influencerId, companyId, campaignId) =>
      dispatch(
        influencerInterestedFromDashboard(
          influencerId,
          companyId,
          campaignId,
          ownProps
        )
      )
  };
};

export default compose(
  // Map redux state to props
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter,
  // Add custom props
  withProps(({ auth, profile }) => ({
    auth,
    profile
  })),
  withFirestore,
  // Flatten profile so that avatarUrl and displayName are props
  flattenProp('profile'),
  // Add styles as classes prop
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/influencer/InfluencerDashboard.enhancer.js